import useCurrentLocale from 'lib/hooks/useCurrentLocale'

import useApiSWR from './useApiSWR'

type CompleteWalkResponse = Record<string, never>

type UseCompleteWalk = (
  walkSlug: string,
  shouldCompleteWalk: boolean
) => { success: boolean; error?: unknown }

const useCompleteWalk: UseCompleteWalk = (walkSlug, shouldCompleteWalk) => {
  const locale = useCurrentLocale()

  const params = {
    WalkID: walkSlug,
    LanguageCode: locale,
  }

  const { data, error } = useApiSWR<CompleteWalkResponse>({
    method: 'POST',
    endpoint: '/api/Progress/CompleteWalk',
    params,
    enabled: shouldCompleteWalk,
    config: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  return { success: data != null, error }
}

export default useCompleteWalk
